var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 27,
    viewBox: "0 0 68 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.525632 21.1497C1.14112 21.7139 4.0658 22.026 6.05756 22.1515C6.01989 21.8729 6.00043 21.5885 6.00043 21.2995C6.00043 17.8201 8.82103 14.9995 12.3004 14.9995C15.7798 14.9995 18.6004 17.8201 18.6004 21.2995C18.6004 21.3749 18.5991 21.4499 18.5964 21.5247H48.0034C48.0008 21.4499 47.9995 21.3749 47.9995 21.2995C47.9995 17.8201 50.8201 14.9995 54.2994 14.9995C57.7788 14.9995 60.5994 17.8201 60.5994 21.2995C60.5994 21.3485 60.5989 21.3973 60.5977 21.446C62.4443 20.7901 65.9092 19.493 66.6004 18.9747C67.3204 18.4347 67.2004 17.6997 67.0504 17.3997L66.0004 17.0247L66.3004 14.0997L65.3254 12.8997V9.5247L59.7754 2.17473V0.899763C53.0504 0.399764 38.1005 -0.300234 32.1005 0.899763C26.1005 2.09976 20.1505 6.29975 17.9255 8.24974C14.6256 8.49974 7.17061 9.31474 3.75062 10.5747C-0.524364 12.1497 -0.374365 20.3247 0.525632 21.1497ZM31.3506 2.84996C27.5706 3.62996 23.2256 7.47494 21.5256 9.29994H36.2256L37.7256 2.54996C37.1756 2.32496 35.1306 2.06996 31.3506 2.84996ZM39.5009 9.00005L40.2743 2.32525L54.2243 3.00025C55.1493 4.00024 56.1743 6.82524 55.6493 7.87523C53.5493 8.47523 44.7259 9.00005 39.5009 9.00005Z",
    fill: "#BABABA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2992,
    cy: 21.3002,
    r: 4.04999,
    stroke: "#BABABA",
    strokeWidth: 2.09999
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.2992,
    cy: 21.3002,
    r: 4.04999,
    stroke: "#BABABA",
    strokeWidth: 2.09999
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossover);
export default ForwardRef;